{
  "version": "0.2.6",
  "extensionId": "objhnmnodmnmjiegkddnfgbjbhfohokm",
  "sha256": "5c839291378ff165928b6fdcf0d06db5c339e8d03d9ceb101ff0320efba80527",
  "bytes": 55388,
  "download": "https://gab.ai/browser-extension/gab-ai-browser-extension-preview.zip",
  "channel": "manual-preview",
  "chatOrigin": "https://gab.ai"
}
